import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Vendor from '../../models/Vendor'

export interface VendorListState extends PaginatedApiState {
  vendors?: Vendor[]
}

const VendorList = (state: VendorListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<VendorListState>('VENDOR_LIST')(state, action)
  }
}

export default VendorList
